import { Token } from 'inversify-token';
import { YinzCamAPI, YinzCamAPIRequest, YinzCamAPIRequestComponent, YinzCamAPIResponse, YinzCamServer } from 'yinzcam-api';

export const YinzCamAppServerToken = new Token<YinzCamAppServer>(Symbol.for("YinzCamAppServer"));

export abstract class YinzCamAppServer {
  private readonly server: YinzCamServer;

  public constructor(private readonly api: YinzCamAPI, private readonly pathPrefix: string) {
    this.server = api.getServer('app', pathPrefix);
  }

  public getRequest(request: YinzCamAPIRequest) {
    return this.server.getRequest(request);
  }

  public getHomeIndex(): YinzCamAPIRequestComponent {
    return this.server.getRequest({ path: 'Home/Index' });
  }

  public getMediaShortList(): YinzCamAPIRequestComponent {
    return this.server.getRequest({ path: 'Media/ShortList' });
  }

  public getGameList(): YinzCamAPIRequestComponent {
    return this.server.getRequest({ path: 'Game/List' });
  }

  public getPlayers(): YinzCamAPIRequestComponent {
    return this.server.getRequest({ path: 'Team/Players' });
  }

  public getPlayerID(id: string): YinzCamAPIRequestComponent {
    console.log(this.server,'/Stats/Player/${id}');
    return this.server.getRequest({ path: `/Stats/Player/${id}` });
  }

  public getMediaNews(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ path: `Media/News/${id}` });
  }

  //yinzchat
  public saveNewGroupRequest(data: any): Promise<YinzCamAPIResponse> {
    console.log('create new group: ', data);
    return this.server.singleRequest({method: 'post', path: `chat`, data});
  }

  public saveNewChatRequest(data: any): Promise<YinzCamAPIResponse> {
    console.log('create new chat: ', data);
    return this.server.singleRequest({method:'post', path: `/drops/${data.Drop_UUID}/messages`, data: {ChatLogItem: data.ChatLogItem}});
  }
}
